import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import {
  ApiPaginationResult,
  ApiResult,
} from '../../shared/models/api-result.model';

@Injectable({
  providedIn: 'root',
})
export class ModelVersionService {
  private http = inject(HttpClient);

  apiBaseUrl = environment.apiBaseUrl;

  getAll(
    pageNumber: number,
    pageSize: number,
    name?: string,
    description?: string,
    isActive?: boolean
  ) {
    let params = '';

    if (name) params += `&name=${name}`;
    if (description) params += `&description=${description}`;
    if (isActive) params += `&isActive=${isActive}`;

    return this.http.get<ApiPaginationResult>(
      this.apiBaseUrl +
        `/api/v1/model-versions?pageNumber=${pageNumber}&pageSize=${pageSize}${params}`
    );
  }

  getById(id: string) {
    return this.http.get<ApiResult>(
      this.apiBaseUrl + '/api/v1/model-versions/' + id
    );
  }

  getDropdownByModel(modelId: string) {
    return this.http.get<ApiResult>(
      this.apiBaseUrl + `/api/v1/model-versions/dropdown?modelId=${modelId}`
    );
  }

  create(data: FormData) {
    return this.http.post<ApiResult>(
      this.apiBaseUrl + '/api/v1/model-versions',
      data
    );
  }

  update(id: string, data: FormData) {
    return this.http.put<ApiResult>(
      this.apiBaseUrl + '/api/v1/model-versions/' + id,
      data
    );
  }

  updateStatus(id: string, isActive: boolean) {
    return this.http.patch<ApiResult>(
      this.apiBaseUrl + `/api/v1/model-versions/${id}/status`,
      { isActive }
    );
  }
}
